"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _styles = _interopRequireDefault(require("./styles"));
var _EditorContainer = require("../Editor/EditorContainer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var TYPE_TOP = 'top';
var TYPE_RIGHT = 'right';
var TYPE_BOTTOM = 'bottom';
var TYPE_LEFT = 'left';
var LINE_TYPE_1 = 'LINE_TYPE_1';
var LINE_TYPE_2 = 'LINE_TYPE_2';
var LINE_TYPE_3 = 'LINE_TYPE_3';
var Ruler = /*#__PURE__*/function (_React$Component) {
  _inherits(Ruler, _React$Component);
  var _super = _createSuper(Ruler);
  function Ruler(props) {
    var _this;
    _classCallCheck(this, Ruler);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getMmInPixel", function (totalWidthMm, totalWidthPx, alignRight, mm) {
      var result = Math.round(mm / totalWidthMm * totalWidthPx);
      return alignRight ? totalWidthPx - result : result;
    });
    _defineProperty(_assertThisInitialized(_this), "drawUnitLine", function (ctx, widthMm, widthPx, heightPx, alignRight, mm, lineType) {
      var lineHeight = heightPx;
      if (lineType === LINE_TYPE_1) {
        lineHeight = Math.round(heightPx / 3);
      } else if (lineType === LINE_TYPE_2) {
        lineHeight = Math.round(heightPx / 2);
      }
      var x = _this.getMmInPixel(widthMm, widthPx, alignRight, mm);
      x += 0.5 * (alignRight ? 1 : -1);
      ctx.moveTo(x, heightPx);
      ctx.lineTo(x, heightPx - lineHeight);
      ctx.stroke();
    });
    _defineProperty(_assertThisInitialized(_this), "drawUnitText", function (ctx, widthMm, widthPx, heightPx, alignRight, rotate, mm) {
      var fontSize = 10;
      var paddingTop = 2;
      var paddingSide = 2;
      ctx.font = "".concat(fontSize, "px Arial");
      ctx.fillStyle = '#000';
      var x = _this.getMmInPixel(widthMm, widthPx, alignRight, mm);
      if (rotate) {
        ctx.save();
        ctx.translate(0, heightPx);
        ctx.rotate(Math.PI);
        ctx.textBaseline = 'alphabetic';
        ctx.textAlign = alignRight ? 'right' : 'left';
        ctx.fillText("".concat(mm, " mm"), -x + paddingSide * (alignRight ? -1 : 1), heightPx - paddingTop);
        ctx.restore();
      } else {
        ctx.textBaseline = 'top';
        ctx.textAlign = alignRight ? 'left' : 'right';
        ctx.fillText("".concat(mm, " mm"), x + paddingSide * (alignRight ? 1 : -1), paddingTop);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "updateCanvas", function () {
      var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props = _this.props,
        type = _this$props.type,
        widthMm = _this$props.width;
      var alignRight = !!_this.props.alignRight;
      var canvas = _this.canvas.current;
      var _canvas$getBoundingCl = canvas.getBoundingClientRect(),
        canvasWidthPx = _canvas$getBoundingCl.width,
        canvasHeightPx = _canvas$getBoundingCl.height;
      if (prevProps.type === type && widthMm === prevProps.width && canvas.width === canvasWidthPx && canvas.height === canvasHeightPx) {
        return;
      }
      canvas.width = canvasWidthPx;
      canvas.height = canvasHeightPx;
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var widthPx = type === TYPE_RIGHT || type === TYPE_LEFT ? canvasHeightPx : canvasWidthPx;
      var heightPx = type === TYPE_RIGHT || type === TYPE_LEFT ? canvasWidthPx : canvasHeightPx;
      if (type === TYPE_RIGHT) {
        ctx.rotate(90 * (Math.PI / 180));
        ctx.translate(0, heightPx * -1);
      } else if (type === TYPE_BOTTOM) {
        ctx.rotate(180 * (Math.PI / 180));
        ctx.translate(widthPx * -1, heightPx * -1);
      } else if (type === TYPE_LEFT) {
        ctx.rotate(270 * (Math.PI / 180));
        ctx.translate(widthPx * -1, 0);
      }
      ctx.strokeStyle = '#999';

      // Steps should be at least 10 pixels wide
      var step = Math.ceil(widthMm * (10 / widthPx));
      for (var i = 0; i <= widthMm; i += step) {
        var lineType = LINE_TYPE_1;
        if (i % (step * 10) === 0) {
          lineType = LINE_TYPE_3;
        } else if (i % (step * 5) === 0) {
          lineType = LINE_TYPE_2;
        }
        _this.drawUnitLine(ctx, widthMm, widthPx, heightPx, alignRight, i, lineType);
        if (i % (step * 10) === 0) {
          _this.drawUnitText(ctx, widthMm, widthPx, heightPx, alignRight, type === TYPE_BOTTOM, i);
        }
      }
    });
    _this.canvas = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _createClass(Ruler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateCanvas();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.updateCanvas(prevProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _classMap;
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        type = _this$props2.type;
      var classMap = (_classMap = {}, _defineProperty(_classMap, TYPE_TOP, "".concat(classes.ruler, " ").concat(classes.rulerTop)), _defineProperty(_classMap, TYPE_RIGHT, "".concat(classes.ruler, " ").concat(classes.rulerRight)), _defineProperty(_classMap, TYPE_BOTTOM, "".concat(classes.ruler, " ").concat(classes.rulerBottom)), _defineProperty(_classMap, TYPE_LEFT, "".concat(classes.ruler, " ").concat(classes.rulerLeft)), _classMap);
      return /*#__PURE__*/_react["default"].createElement("canvas", {
        ref: this.canvas,
        className: classMap[type]
      });
    }
  }]);
  return Ruler;
}(_react["default"].Component);
_defineProperty(Ruler, "propTypes", {
  classes: _propTypes["default"].object.isRequired,
  width: _propTypes["default"].number.isRequired,
  type: _propTypes["default"].oneOf([TYPE_TOP, TYPE_RIGHT, TYPE_BOTTOM, TYPE_LEFT]).isRequired,
  alignRight: _propTypes["default"].bool
});
_defineProperty(Ruler, "defaultProps", {
  alignRight: false
});
var _default = exports["default"] = (0, _withStyles["default"])(_styles["default"], {
  name: 'Designer-Ruler'
})((0, _EditorContainer.withCanvasPosition)(Ruler));